<template>
  <div id="partners">
    <b-loading
      :is-full-page="fullPage"
      :active.sync="getLoadingPartners"
    ></b-loading>
    <div
      v-for="(partnerType, index) in getPartners"
      :key="index"
      class="partner-type"
    >
      <h2>{{ $t(partnerType.name) }}</h2>
      <div class="partners-list">
        <div
          class="partner-container"
          v-for="(partner, index2) in partnerType.content"
          :key="index2"
        >
          <a class="partner" :href="partner.link">
            <img :src="partner.logo" :alt="partner.name" loading="lazy"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      fullPage: false,
    };
  },
  computed: {
    ...mapGetters("partnersModule", ["getPartners", "getLoadingPartners"]),
  },
  methods: {
    ...mapActions("partnersModule", ["requestPartners"]),
  },
  mounted() {
    this.requestPartners();
  },
};
</script>

<style scoped lang="scss">
#partners {
  padding-top: 10vh;
  // @extend %eestec-page;
  background-color: #fff;
}
.partner-type {
  margin: auto;
  width: 80%;
}

h1,
h2 {
  color: #0d2a4c;
  font-family: "Acumin Variable Concept";
  font-size: 69px;
}

.partner-row img {
  height: 100%;
}

h2 {
  display: block;
  font-weight: bold;
  font-size: 3.5vw;
  letter-spacing: 1px;
  text-align: center;
  margin-top: 50px;
  padding-bottom: 1vh;
}

.partners-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.partner {
  margin: 0.5em 0.75em;
}

.partner > img {
  filter: grayscale(100%);
  opacity: 0.66;
  transition: all 0.3s ease;
  max-height: 10vh;
  margin: 1vh 1vw 1vh 1vw;
}

.partner > img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

// .partner-type:first-child .partner-container:first img {
//   height: 15vh;
// }

.partner-type:last-child {
  padding-bottom: 10vh;
}

// .partner-type:first-child .partner-container:first-child img {
//   max-height: 20vh;
// }

// .partner-type:nth-child(2) img {
//   max-height: 10vh;
// }

// .partner-type:nth-child(2) .partner-container:nth-child(3) img {
//   max-height: 11.5vh;
// }

// .partner-type:nth-child(3) img {
//   height: 100vh;
// }

// .partner-type:nth-child(4) img {
//   max-height: 13vh;
// }

// .partner-type:nth-child(5) img {
//   max-height: 12vh;
// }

// .partner-type:nth-child(5) .partner-container:first-child img {
//   max-height: 15vh;
// }

// .partner-type:nth-child(6) .partner-container:nth-child(2) img {
//   max-height: 10vh;
// }

// .partner-type:nth-child(6) .partner-container:nth-child(3) img {
//   max-height: 10vh;
// }

// .partner-type:nth-child(7) img {
//   max-height: 10vh;
// }

@media only screen and (max-width: 600px) {
  #partners {
    padding-top: 30vh;
  }

  h1 {
    font-size: 10vw;
    margin-bottom: 0vh;
  }

  h2 {
    font-size: 5vw;
  }

  .partner-container {
    margin-top: 20px;
  }

  .partner > img {
    filter: grayscale(0%);
    opacity: 1;
  }
}
</style>
